<template>
    <div id="dashboard-page" style="margin-bottom:55px;">
        <b-card>
            <b-row>
              <b-col md="12">
              <h3>{{$route.name}}</h3>
              <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/company-structure/supplier">Supplier</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
              </b-breadcrumb>
              <div class="border-bottom"></div>
             </b-col>
            </b-row>
            <b-form class="mt-3 mx-2">
              <b-row>
                <b-col md="6">
                  <b-row>
                    <b-col md="4"><label class="labels">Supplier ID</label></b-col>
                    <b-col md="8"><p>{{ model.supplierId !== undefined && model.supplierId !== null && model.supplierId !== '' ? model.supplierId : '-'}}</p></b-col>
                  </b-row>
                 
                  <b-row>
                    <b-col md="4" v-if="model.type === 'Company'"><label class="labels">Supplier Name</label></b-col>
                    <b-col md="4" v-else><label class="labels">Supplier Name</label></b-col>
                    <b-col md="8"><p>{{ model.name !== undefined && model.name !== null && model.name !== '' ? model.name : '-'}}</p></b-col>
                  </b-row>

                  <b-row>
                    <b-col md="4"><label class="labels">Telephone</label></b-col>
                    <b-col md="8"><p>{{ model.phone !== undefined && model.phone !== null && model.phone !== '' ? model.phone : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">Fax Number</label></b-col>
                    <b-col md="8"><p>{{ model.fax !== undefined && model.fax !== null && model.fax !== '' ? model.fax : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">Website</label></b-col>
                    <b-col md="8"><p>{{ model.website !== undefined && model.website !== null && model.website !== '' ? model.website : '-'}}</p></b-col>
                  </b-row>
                  <!-- <b-row>
                    <b-col md="4"><label class="labels">Social Media</label></b-col>
                    <b-col md="8">
                      <tbody v-if="model.socialMediaList.length > 0">
                        <tr v-for="socialMedia in model.socialMediaList" :key="socialMedia" >
                          <td>
                            <li>{{socialMedia}}</li>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="9" class="text-center">-</td>
                        </tr>
                      </tbody>
                    </b-col>
                  </b-row> -->
                </b-col>
                <b-col md="6">
                  <b-row>
                    <b-col md="4"><label class="labels">Email</label></b-col>
                    <b-col md="8"><p>{{ model.email !== undefined && model.email !== null && model.email !== '' ? model.email : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">Tax ID</label></b-col>
                    <b-col md="8"><p>{{ model.taxId !== undefined && model.taxId !== null && model.taxId !== '' ? model.taxId : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">Address</label></b-col>
                    <b-col md="8"><p class="text-justify">{{ model.address !== undefined && model.address !== null && model.address !== '' ? model.address : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">State</label></b-col>
                    <b-col md="8"><p>{{ model.state !== undefined && model.state !== null && model.state !== '' ? model.state : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">City</label></b-col>
                    <b-col md="8"><p>{{ model.city !== undefined && model.city !== null && model.city !== '' ? model.city : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">Postal Code</label></b-col>
                    <b-col md="8"><p>{{ model.postalCode !== undefined && model.postalCode !== null && model.postalCode !== '' ? model.postalCode : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">Description</label></b-col>
                    <b-col md="8"><p class="text-justify">{{ model.description !== undefined && model.description !== null && model.description !== '' ? model.description : '-'}}</p></b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-form>
            <b-button class="mt-5" :to="'/company-structure/supplier'" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
            <b-button class="mt-5 float-right" :to="'/company-structure/supplier/' + $route.params.uuid + '/edit'" variant="warning"><font-awesome-icon icon="pencil-alt"></font-awesome-icon> Edit</b-button>
        </b-card>
    </div>
</template>

<script>
    import 'viewerjs/dist/viewer.css'
    import Viewer from 'v-viewer'
    import Vue from 'vue'
    Vue.use(Viewer)

    export default {
        name: 'supplier-details',
        data () {
          return {
            isLoading: false,
            apiUrl: {
              supplier: window.AppConfig.apiUrl + 'supplier'
            },
            model: {
              supplierId: '',
              website: '',
              fax: '',
              city: '',
              state: '',
              postalCode: '',
              description: '',
              taxId: '',
              taxCategory: '',
              name: '',
              gender: '',
              workphone: '',
              email: '',
              workemail: '',
              address: '',
              picName: '',
              whatsapp: '',
              phone: '',
              accountNumber: '',
              accountName: '',
              bank: '',
              accountType: '',
              accountSubtype: '',
              qrCode: null,
              socialMediaList: [],
              socialMedia: '',
              customerGroupList: []
            },
          }
        },
        mounted () {
          this.getDetail()
        },
        methods: {
          getDetail () {
            this.isLoading = true
            this.$http.get(this.apiUrl.supplier + '/' + this.$route.params.uuid).then(response => {
              this.model.supplierId = response.data.supplierId !== null && response.data.supplierId !== 'null' ? response.data.supplierId : '-'
              this.model.name = response.data.name !== null && response.data.name !== 'null' ? response.data.name : '-'
              this.model.address = response.data.address !== null && response.data.address !== 'null' ? response.data.address : '-'
              this.model.phone = response.data.phone !== null && response.data.phone !== 'null' ? response.data.phone : '-'
              this.model.email = response.data.email !== null && response.data.email !== 'null' ? response.data.email : '-'
              this.model.workemail = response.data.workemail !== null && response.data.workemail !== 'null' ? response.data.workemail : '-'
              this.model.taxId = response.data.taxId !== null && response.data.taxId !== 'null' ? response.data.taxId : '-'
              this.model.taxCategory = response.data.taxCategory !== null || response.data.taxCategory !== 'null' ? response.data.taxCategory : '-'
              this.model.description = response.data.description !== null && response.data.description !== 'null' ? response.data.description : '-'
              this.model.fax = response.data.fax !== null && response.data.fax !== 'null' ? response.data.fax : '-'
              this.model.website = response.data.website !== null && response.data.website !== 'null' ? response.data.website : '-'
              this.model.city = response.data.city !== null && response.data.city !== 'null' ? response.data.city : '-'
              this.model.state = response.data.state !== null && response.data.state !== 'null' ? response.data.state : '-'
              this.model.postalCode = response.data.postalCode !== null && response.data.postalCode !== 'null' ? response.data.postalCode : '-'
              this.model.picName = response.data.picName !== null && response.data.picName !== 'null' ? response.data.picName : '-'
              this.model.whatsapp = response.data.whatsapp !== null && response.data.whatsapp !== 'null' ? response.data.whatsapp : '-'
              this.model.workphone = response.data.workphone !== null && response.data.workphone !== 'null' ? response.data.workphone : '-'
              this.socialMediaList = []
              if (response.data.socialMedia !== null) {
                response.data.socialMedia.forEach(data => {
                  this.model.socialMediaList.push(data)
                })
              }
            })
          },
          // doPrintQRCode () {
          //   var urlQrCode = this.model.qrCode
          //   var win = window.open('' )
          //   var img=win.document.createElement("img")
          //   img.src= urlQrCode
          //   win.document.body.appendChild(img)
          //   img.onload = function(){
          //     // win.open()
          //     win.print()
          //   }
          // },
          getDateTime (value) {
            if (value !== null) {
              return this.$moment(value).format('YYYY-MM-DD HH:mm A')
            } else {
              return '-'
            }
          },
          goBack () {
            window.goBack(this)
          },
          getStatusColor (val) {
            if (val) {
              return "success"
            } else {
              return "secondary"
            }
          },
          getStatusName (val) {
            if (val) {
              return "Headquarters"
            } else {
              return "Branch"
            }
          }
        }
    }
</script>